import { render, staticRenderFns } from "./AkTextSmall.vue?vue&type=template&id=47740532&"
import script from "./AkTextSmall.vue?vue&type=script&lang=js&"
export * from "./AkTextSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/wisseloord/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47740532')) {
      api.createRecord('47740532', component.options)
    } else {
      api.reload('47740532', component.options)
    }
    module.hot.accept("./AkTextSmall.vue?vue&type=template&id=47740532&", function () {
      api.rerender('47740532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/AkTextSmall.vue"
export default component.exports